module.exports = __webpack_public_path__ + "img/chinesecompany13.e463bd0b.png";